// extracted by mini-css-extract-plugin
module.exports = {"video_container":"EventPlayer_video_container__1Z-R-","video_controls":"EventPlayer_video_controls__2FvOR"};